import { debounce } from 'lodash-es'

// 发布
export const usePublishModal = debounce(
  (record: any, key: 'personal' | 'team') => {
    const publishInfo = usePublishInfo()

    publishInfo.value = {
      ...record,
      room_type: key === 'personal' ? 0 : 1,
    }

    // const onCancel = () => {
    //   modal.destroy();
    // };
    // const modal = useEmptyModal({
    //   width: 656,
    //   wrapClassName: 'xmov-form-modal publish-form-modal',
    //   title: '发布视频',
    //   closable: true,
    //   centered: false,
    //   onCancel,
    //   content: [
    //     <PublishTemplate data={record} onSuccess={onCancel} />,
    //   ],
    // });
    // return modal;
  },
  100
)

// 发布进度
// export const usePublishProgressModal = debounce(() => {
//   // console.log(modal, 'dddd')
//   const onCancel = () => {
//     modal.destroy();
//   };
//   const modal = useEmptyModal({
//     width: 500,
//     mask: false,
//     wrapClassName: 'youyan-share-progress',
//     content: [
//       <PublishProgress onClose={onCancel} />,
//     ],
//   });
//   return modal;
// }, 200);
